import { createDateRangeFromDays } from './createDateRangeFromDays';
import { IEscrowExpectedIncomingCheckQuery } from '../../types/accounting/query/IEscrowExpectedIncomingCheckQuery';
import { IEscrowExpectedIncomingWireQuery } from '../../types/accounting/query/IEscrowExpectedIncomingWireQuery';
import { eMatchedQueryValue } from '../../types/accounting/eMatchedQueryValue';
import { IEscrowExpectedIncomingAchQuery } from '../../types/accounting/query/IEscrowExpectedIncomingAchQuery';

const SIZE_PER_PAGE = 25;

export type ICreateQueryFromAmountCents<Query> = (
  amountCents: number,
  amountCentsMax: number,
  pageSize?: number
) => Query;

export const createCheckQueryFromAmountCents: ICreateQueryFromAmountCents<IEscrowExpectedIncomingCheckQuery> = (
  amountCents: number,
  amountCentsMax: number,
  pageSize: number = SIZE_PER_PAGE
) => ({
  createdAt: createDateRangeFromDays(-30),
  amountCents,
  amountCentsMax,
  matched: eMatchedQueryValue.UNMATCHED,
  pageNumber: 1,
  pageSize,
  sortField: undefined,
  sortOrder: undefined,
});

export const createWireQueryFromAmountCents: ICreateQueryFromAmountCents<IEscrowExpectedIncomingWireQuery> = (
  amountCents: number,
  amountCentsMax: number,
  pageSize: number = SIZE_PER_PAGE
) => ({
  amountCents,
  amountCentsMax,
  bankAccountName: undefined,
  createdAt: createDateRangeFromDays(-30),
  matched: eMatchedQueryValue.UNMATCHED,
  pageNumber: 1,
  pageSize,
  sortField: undefined,
  sortOrder: undefined,
});

export const createAchQueryFromAmountCents: ICreateQueryFromAmountCents<IEscrowExpectedIncomingAchQuery> = (
  amountCents: number,
  amountCentsMax: number,
  pageSize: number = SIZE_PER_PAGE
) => ({
  amountCents,
  amountCentsMax,
  createdAt: createDateRangeFromDays(-30),
  matched: eMatchedQueryValue.UNMATCHED,
  pageNumber: 1,
  pageSize,
  sortField: undefined,
  sortOrder: undefined,
});
